/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { useSimpliCity } from "cms/hooks/use-simplicity";
import { Component } from "cms/fields/component";
import React, { Fragment } from "react";

const HomeContent = () => {

    const { webpage, model, fields } = useSimpliCity();
    // {Selectively showing just the field called "content" of type "field.component"
    const content = fields?.content;

    return (
        <Fragment>
            {fields &&
                <Component
                    field={content}
                    model={model}
                    webpage={webpage}
                />
            }
        </Fragment>
    );
};
HomeContent.displayName = "HomeContent";
export { HomeContent };
